import React from 'react';
import { connect } from 'react-redux';
import {
  Col,
  Button,
  Spinner,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/pro-duotone-svg-icons';
import { faTimes, faPlus, faMinusCircle } from '@fortawesome/pro-light-svg-icons';

import { saveUpdatedTranslations } from '../../../actions/translations';

class LanguageModifyButtons extends React.PureComponent {
  render() {
    const {
      translations,
      saving,
      edit,
      site,
    } = this.props;

    return (
      <Col className="text-right">
        {edit
          ? (
            <div className="d-inline">
              <Button
                color="danger"
                className="me-2"
                onClick={() => {
                  const { dispatch } = this.props;
                  dispatch({ type: 'EDIT_TRANSITION_OBJECT', payload: false });
                  dispatch({ type: 'RESET_TRANSITION_OBJECT' });
                }}
              >
                <FontAwesomeIcon icon={faTimes} size="lg" className="me-2" />
                Cancel
              </Button>
              <Button
                color="secondary"
                disabled={saving}
                onClick={() => saveUpdatedTranslations(translations, site)}
              >
                <FontAwesomeIcon icon={faSave} size="lg" className="me-2" />
                Save
                {saving && <Spinner size="sm" className="ms-2" />}
              </Button>
            </div>
          )
          : (
            <Button
              color="secondary"
              onClick={() => {
                const { dispatch } = this.props;
                dispatch({ type: 'EDIT_TRANSITION_OBJECT', payload: true });
              }}
            >
              <FontAwesomeIcon icon={faEdit} size="lg" className="me-2" />
              Edit
            </Button>
          )}
        <Button
          color="success"
          className="ms-2"
          onClick={() => {
            const { dispatch } = this.props;
            dispatch({ type: 'EDIT_TRANSITION_OBJECT', payload: false });
            dispatch({ type: 'RESET_TRANSITION_OBJECT' });
            dispatch({ type: 'SET_ADD_TRANSLATION_MODAL', payload: true });
          }}
        >
          <FontAwesomeIcon icon={faPlus} size="lg" className="me-2" />
          Add
        </Button>
        <Button
          color="danger"
          className="ms-2"
          onClick={() => {
            const { dispatch } = this.props;
            dispatch({ type: 'EDIT_TRANSITION_OBJECT', payload: false });
            dispatch({ type: 'RESET_TRANSITION_OBJECT' });
            dispatch({ type: 'SET_DELETE_TRANSLATION_MODAL', payload: true });
          }}
        >
          <FontAwesomeIcon icon={faMinusCircle} size="lg" className="me-2" />
          Delete
        </Button>
      </Col>
    );
  }
}

const mapStateToProps = (store) => ({
  translations: store.translations.sets,
  saving: store.translations.saving,
  edit: store.translations.edit,
});

export default connect(mapStateToProps)(LanguageModifyButtons);
